<template lang="pug">
.custom-input-select
  span.label {{displayValue}}
  select(ref="selectElm" :value="value" @input="$emit('input', $event.target.value)")
    slot
  .sizing-helper
    .text {{displayValue}}
    //- .arrow-container: .arrow
    i.fa.fa-angle-down.ml-3(style='color: #0092C9')
</template>

<script>
export default {
  data: () => ({
    displayValue: '',
  }),
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        const filteredList = this.$slots.default.filter((elm) => {
          if (!('attrs' in elm.data) && !('domProps' in elm.data)) return false;
          if ('attrs' in elm.data && 'value' in elm.data.attrs && elm.data.attrs.value === newVal) {
            return true;
          }
          if ('domProps' in elm.data && 'value' in elm.data.domProps && elm.data.domProps.value === newVal) {
            return true;
          }
          return false;
        });
        if (filteredList.length === 0) return;
        this.displayValue = filteredList[0].children[0].text;
      },
    },
  },
  props: ['value'],
};
</script>

<style lang="scss">
.custom-input-select {
  position: relative;
  font-size: 18px;
  // height: 24px;
  span.label {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    pointer-events: none;
    width: 100%;
  }
  .sizing-helper { // For sizing
    pointer-events: none;
    width: 100%;
    display: flex;
    align-items: center;
    .text {
      flex: 1;
      opacity: 0;
    }
    .arrow-container {
      flex: 0 0 36px;
      display: flex;
      align-items: center;
      .arrow {
        right: 24px;
        width: 12px;
        height: 12px;
        transform: rotate(-45deg);
        border-left: 1px solid var(--primary);
        border-bottom: 1px solid var(--primary);
      }
    }
  }
  select {
    opacity: 0;
    position: absolute;
    left: 50%;
    width: 100%;
    transform: translateX(-50%);
  }
}
</style>
